angular.module('unica_transfer.transfer_services')

.factory('TransferDeleteService', function ($http, getBaseApiURL) {

	var transferDeleteService = {};

	transferDeleteService.delete = function (transferId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/transfer/delete/' + transferId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return transferDeleteService;
});